<div class="d-flex flex-column align-items-center justify-content-center box-catalog">
  <div class="d-flex flex-column align-items-center justify-content-between box-catalog-header w-100">
    <div class="box-catalog-info">
      <span class="text-uppercase box-catalog-subtitle"
            [style.color]="colorSubtitle">{{subTitle}}</span>
      <h3 class="text-uppercase elsa-title-font box-catalog-title">{{title}}</h3>
    </div>
    <img class="box-catalog-img" src="{{image}}" alt="{{title}}">
  </div>
  <div class="w-100 box-catalog-spacer d-flex flex-row justify-content-center">
    <div class="box-catalog-description-inner font-weight-bold" [innerHTML]="text | safeHtml"></div>
  </div>
  <a [routerLink]="url.path" [fragment]="url.fragment" class="btn text-white btn-go-to-section text-uppercase btn-gray"
     [title]="title" appEmptyTitle>{{'go_to_section' | translate}}</a>
</div>
